export const columns = [
  {
    title: '发起预病历',
    dataIndex: 'operatorName',
    key: 'operatorName',
    slots: { customRender: 'operatorName' }
  },
  {
    title: '患者姓名',
    dataIndex: 'patientName',
    key: 'patientName',
    slots: { customRender: 'patientName' }
  },
  {
    title: '医生姓名',
    dataIndex: 'doctorName',
    key: 'doctorName'
  },
  // {
  //   title: '预病历ID',
  //   dataIndex: 'advanceMedicalRecordId',
  //   key: 'advanceMedicalRecordId'
  // },
  {
    title: '创建预病历时间',
    dataIndex: 'createTime',
    key: 'createTime'
  },
  {
    title: '预病历状态',
    dataIndex: 'recordState',
    key: 'recordState',
    width: 120,
    customRender: ({ text }) => {
      // 0：待确认 1：已确认 2:驳回 3:已失效
      // return text === 0 ? '待确认' : text === 1 ? '已确认' : text === 2 ? '驳回' : '已失效'
      const typeMap = {
        0: '待医生确认',
        1: '医生已确认',
        2: '医生已驳回',
        3: '已失效'
      }
      return typeMap[text] || '未知类型'
    }
  },
  // {
  //   title: '预病历类型',
  //   dataIndex: 'advanceMedicalRecordType',
  //   key: 'advanceMedicalRecordType',
  //   customRender: ({ text }) => {
  //     // 类型1：西药联合，2：配方颗粒，3：用药建议，4: 量表的预病历，5：患者直接开预病历，6：健管预病历。1和2是BD预病历这里固定6
  //     const typeMap = {
  //       1: '西药联合',
  //       2: '配方颗粒',
  //       3: '用药建议',
  //       4: '量表的预病历',
  //       5: '患者直接开预病历',
  //       6: '健管预病历'
  //     }
  //     return typeMap[text] || '未知类型'
  //   }
  // },
  // {
  //   title: '创建预病历时间',
  //   dataIndex: 'createTime',
  //   key: 'createTime'
  // },
  {
    title: '医生开方时间',
    dataIndex: 'doctorApproveTime',
    key: 'doctorApproveTime'
  },
  {
    title: '处方购买状态',
    dataIndex: 'buyState',
    key: 'buyState',
    customRender: ({ text }) => {
      // 0:未购 1:部分购买 2:全部购买 3:已下单未支付
      const typeMap = {
        0: '待购买',
        1: '部分购买',
        2: '已购买',
        3: '已下单未支付'
      }
      return typeMap[text] || '--'
    }
  },
  {
    title: '患者购买时间',
    dataIndex: 'patientBuyTime',
    key: 'patientBuyTime'
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    key: 'action',
    slots: { customRender: 'action' },
    width: 270
  }
]
